import React, { useState } from "react";

//UI Material
import { Card, Divider, Grid, Stack } from "@mui/material";

//Material Icons
import { Edit, Error } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Local Components
import ContainedButton from "../basics/ContainedButton";
import BillingDrawer from "../drawers/BillingDrawer";

export default function OrderBilling({ order, getData, canEdit = false }) {
  //State for open/close billing drawer
  const [billingDrawerOpen, setBillingDrawerOpen] = useState(false);

  // ==========>Component<==========
  return (
    <Card raised sx={{ height: "100%" }}>
      {canEdit && (
        <BillingDrawer
          open={billingDrawerOpen}
          setOpen={setBillingDrawerOpen}
          order={order}
          orderNumber={new URLSearchParams(window.location.search).get(
            "orderId"
          )}
          getData={getData}
        />
      )}
      <Grid container spacing={1} sx={{ padding: "15px" }}>
        <Grid item xs={12}>
          {Number(order.billing.amount) === 0 ? (
            <Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <Error color="error" />
                {typographyForSubtitles("Facturación", "secondary")}
              </Stack>
              {typographyForCustomizedFontSize(
                "Sin información de facturación.",
                "11px",
                "#D32F2F"
              )}
            </Stack>
          ) : (
            typographyForSubtitles("Facturación", "secondary")
          )}
        </Grid>
        <Grid item xs={12}>
          {typographyForMainTitles(
            `$ ${Number(order.billing.amount).toFixed(2)}`
          )}
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            {typographyForCustomizedFontSize(
              "Monto sin impuestos (USD)",
              "11px",
              null,
              "bold"
            )}
            {typographyForText(
              `$${Number(order.billing.pretax).toFixed(2)}`,
              "bold"
            )}
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            {typographyForCustomizedFontSize("IVA (USD)", "11px", null, "bold")}
            {typographyForText(
              `$${Number(order.billing.taxes).toFixed(2)}`,
              "bold"
            )}
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            {typographyForCustomizedFontSize(
              "Monto total (USD)",
              "11px",
              null,
              "bold"
            )}
            {typographyForText(
              `$${Number(order.billing.amount).toFixed(2)}`,
              "bold"
            )}
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            {typographyForCustomizedFontSize(
              "Información adicional",
              "11px",
              null,
              "bold"
            )}
            {typographyForText(order.billing.aditional, "bold")}
          </Stack>
        </Grid>
        {canEdit && (
          <Grid item xs={12} sx={{ marginTop: "10px" }}>
            <ContainedButton
              text={"editar facturación"}
              endIcon={<Edit />}
              onClick={setBillingDrawerOpen}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
}
